// based on old SCM, example of the result: 2022-04-26 7:59:56 +0000
export const DATE_FORMAT_FOR_NOTES = 'yyyy-MM-dd H:mm:ss +0000'
